import { ApiRegion, LegacyApiRegion, LegacyRegion, Region } from '@/features/destinations/utils/Region';

export const legacyDestinationRegionLabelMapper: { [key in LegacyApiRegion]: LegacyRegion } = {
  [LegacyApiRegion.Africa]: LegacyRegion.Africa,
  [LegacyApiRegion.Alaska]: LegacyRegion.Alaska,
  [LegacyApiRegion.Asia]: LegacyRegion.Asia,
  [LegacyApiRegion.EasternEurope]: LegacyRegion.EasternEurope,
  [LegacyApiRegion.AustraliaAndNewZealand]: LegacyRegion.AustraliaAndNewZealand,
  [LegacyApiRegion.Caribbean]: LegacyRegion.Caribbean,
  [LegacyApiRegion.CentralAndSouthAmerica]: LegacyRegion.CentralAndSouthAmerica,
  [LegacyApiRegion.CentralWesternEurope]: LegacyRegion.CentralWesternEurope,
  [LegacyApiRegion.Hawaii]: LegacyRegion.Hawaii,
  [LegacyApiRegion.ScandinaviaAndIceland]: LegacyRegion.ScandinaviaAndIceland,
  [LegacyApiRegion.SouthernEuropeAndMediterranean]: LegacyRegion.SouthernEuropeAndMediterranean,
  [LegacyApiRegion.Mexico]: LegacyRegion.Mexico,
  [LegacyApiRegion.TahitiAndSouthPacific]: LegacyRegion.TahitiAndSouthPacific,
  [LegacyApiRegion.UKAndIreland]: LegacyRegion.UKAndIreland,
  [LegacyApiRegion.USAAndCanada]: LegacyRegion.USAAndCanada,
  [LegacyApiRegion.Other]: LegacyRegion.Other,
};

export const destinationRegionLabelMapper: { [key in ApiRegion]: Region } = {
  [ApiRegion.AfricaNorth]: Region.AfricaNorth,
  [ApiRegion.AfricaSafariEastSouthern]: Region.AfricaSafariEastSouthern,
  [ApiRegion.ArcticAntarctica]: Region.ArcticAntarctica,
  [ApiRegion.AsiaEast]: Region.AsiaEast,
  [ApiRegion.AsiaSouth]: Region.AsiaSouth,
  [ApiRegion.AsiaSoutheast]: Region.AsiaSoutheast,
  [ApiRegion.AustraliaAndNewZealand]: Region.AustraliaAndNewZealand,
  [ApiRegion.Canada]: Region.Canada,
  [ApiRegion.CaribbeanEasternSouthern]: Region.CaribbeanEasternSouthern,
  [ApiRegion.CaribbeanWestern]: Region.CaribbeanWestern,
  [ApiRegion.CentralAmerica]: Region.CentralAmerica,
  [ApiRegion.EuropeanEastern]: Region.EuropeanEastern,
  [ApiRegion.EuropeanMediterranean]: Region.EuropeanMediterranean,
  [ApiRegion.EuropeanUKAndIreland]: Region.EuropeanUKAndIreland,
  [ApiRegion.EuropeanWesternNorthern]: Region.EuropeanWesternNorthern,
  [ApiRegion.Mexico]: Region.Mexico,
  [ApiRegion.MiddleEast]: Region.MiddleEast,
  [ApiRegion.SouthAmerica]: Region.SouthAmerica,
  [ApiRegion.SouthPacific]: Region.SouthPacific,
  [ApiRegion.Unknown]: Region.Unknown,
  [ApiRegion.Alaska]: Region.Alaska,
  [ApiRegion.Hawaii]: Region.Hawaii,
  [ApiRegion.USAMainland]: Region.USAMainland,
};

export const getDestinationRegionLabel = (
  name: string,
  useNewDestinations: boolean,
): string => {
  if (useNewDestinations) {
    return destinationRegionLabelMapper[name as ApiRegion] ?? name;
  }
  return legacyDestinationRegionLabelMapper[name as LegacyApiRegion] ?? name;
};
